import App from "@/App.vue";

export default [
  {
    path: "/propostas",
    name: "proposal",
    component: App,
    redirect: { name: "list proposal" },
    children: [
      {
        path: "",
        name: "list proposal",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/ProposalList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Propostas",
              disabled: false,
              link: false,
              to: { name: "proposal" }
            }
          ],
          displayName: "Lista Propostas - Lockton",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/apolices",
    name: "policy",
    component: App,
    redirect: { name: "list policy" },
    children: [
      {
        path: "",
        name: "list policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/PolicyList.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Apólices",
              disabled: false,
              link: false,
              to: { name: "policy" }
            }
          ],
          displayName: "Lista Apólices - Lockton",
          requiresAuth: true
        }
      },
      {
        path: "nova-apolice",
        name: "new policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewPolicy.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Nova Apólice",
              disabled: false,
              link: false,
              to: { name: "policy" }
            }
          ],
          displayName: "Nova Apólice - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_apolice"
        }
      },
      {
        path: ":id/detalhes-apolice",
        name: "details policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/DetailsPolicy.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Apólice",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Detalhes da Apólice - Lockton",
          requiresAuth: true,
          permissionRoute: "detalhe_apolice"
        }
      },
      {
        path: ":id/detalhes-apolice/novo-endosso",
        name: "new endorsement policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewEndorsement.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Novo Endosso",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Novo Endosso - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_endosso"
        }
      },
      {
        path: ":id/editar-apolice",
        name: "edit policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditPolicy.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Editar Apólice",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Editar Apólice - Lockton",
          requiresAuth: true,
          permissionRoute: "editar_apolice"
        }
      },
      {
        path: ":id/detalhes-apolice/:endosso/editar-endosso",
        name: "edit endorsement policy",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Editar Endosso",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Editar Endosso - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":id/detalhes-apolice/nova-solicitacao-endosso",
        name: "new endorsement request policy",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewRequestEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Nova Solicitação",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Nova Solicitação Endosso - Lockton",
          requiresAuth: true,
          permissionRoute: "solicitar_endosso"
        }
      },
      {
        path: ":id/cancelamento-apolice",
        name: "cancel policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/CancelPolicy.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Cancelamento Apólice",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Cancelamento Apólice - Lockton",
          requiresAuth: true,
          permissionRoute: "solicitar_endosso"
        }
      },
      {
        path: ":id/cancelamento-endosso/:numero",
        name: "cancel endorsement policy",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/CancelEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Cancelamento Endosso",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Cancelamento Endosso - Lockton",
          requiresAuth: true,
          permissionRoute: "solicitar_endosso"
        }
      },
      {
        path: ":id/detalhes-apolice/:endosso/editar-solicitacao",
        name: "edit endorsement request policy",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/EditRequestEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Editar Solicitação Endosso",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Editar Solicitação Endosso - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":id/detalhes-apolice/:endosso/criticas",
        name: "criticism endorsement policy",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/CriticismEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Critícas Endosso",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Critícas Endosso - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":id/detalhes-apolice/:endosso/nova-criticas",
        name: "new criticism endorsement policy",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/NewCriticismEndorsement.vue"
          ),
        meta: {
          breadcrumb: [
            {
              text: "Nova Critíca Endosso",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Nova Critíca Endosso - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":id/criticas",
        name: "criticism policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Criticism.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Critíca Apólice",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Critíca Apólice - Lockton",
          requiresAuth: true
        }
      },
      {
        path: ":id/nova-critica",
        name: "new criticism policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewCriticism.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Nova Critíca Apólice",
              disabled: false,
              link: true,
              to: { name: "policy" }
            }
          ],
          displayName: "Nova Critíca Apólice - Lockton",
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: "/faturas",
    name: "policy invoice",
    component: App,
    redirect: { name: "list policy" },
    children: [
      {
        path: "nova-fatura",
        name: "new invoice policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewInvoice.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Criar Fatura",
              disabled: false,
              link: true,
              to: { name: "policy", params: { currentTab: 1 } }
            }
          ],
          displayName: "Criar Fatura - Lockton",
          requiresAuth: true,
          permissionRoute: "criar_fatura"
        }
      },
      {
        path: ":id/editar-fatura",
        name: "edit invoice policy",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/EditInvoice.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Editar Fatura",
              disabled: false,
              link: true,
              to: { name: "policy", params: { currentTab: 1 } }
            }
          ],
          displayName: "Editar Fatura - Lockton",
          requiresAuth: true,
          permissionRoute: "editar_fatura"
        }
      }
    ]
  }
];
